import {Component, Input, SimpleChanges, OnChanges} from '@angular/core';
import {WordProvider} from "../../providers/word/word";
import {ToastController, ModalController} from "ionic-angular/index";

/**
 * Generated class for the HotWordComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: 'hot-word',
  templateUrl: 'hot-word.html'
})
export class HotWordComponent implements OnChanges{


  @Input() scope;
  @Input() choosedChatroom;

  constructor(public wordService:WordProvider,public toast:ToastController,public _modal:ModalController) {
    console.log('Hello HotWordComponent Component');
  }

  ngOnChanges(changes:SimpleChanges){
    this.hotWords = [];
    this.getHotWords();
  }


  scopes = [
    { name: '今日', value: 1 },
    {name:'昨天',value:2},
    { name: '7天', value: 3 },
    { name: '30天', value: 4 },
    { name: '全部', value: 5 },
  ];

  //热词榜
  wordTypeIndex = 0;
  word_type = [
    {
      name:'名词',
    },
    {
      name:'动词',
    },
    {
      name:'形容词',
    }
  ];
  toggleWordType(index){
    if(index != this.wordTypeIndex){
      this.wordTypeIndex = index;
      this.getHotWords();
    }
  }
  is_add_word;
  add_word = '';
  add_words = [];
  showAddWord(){
    this.is_add_word = true;
  }
  addNewWord(){
    if(this.add_word.trim().length && this.add_word.trim().length < 17){
      this.wordService.addKeyword(this.add_word.trim()).subscribe(res =>{
        this.is_add_word = false;
        this.add_word = '';
        this.add_words.push(this.add_word.trim());
      },err =>{
        if(err.err_name == ''){
          let toast = this.toast.create({
            message:'添加新词失败，请重试',
            duration: 1500
          });
          toast.present();
        }
      })
    }
  }

  is_loading_keyword;
  is_error_keyword;
  getKeyword(){
    this.is_loading_keyword = true;
    this.is_error_keyword = false;
    this.wordService.getKeyword().subscribe(res =>{
      this.is_loading_keyword = false;
      this.is_error_keyword = false;
      this.add_words = res['content']['custorm_data'];
    },err =>{
      this.is_error_keyword = true;
      this.is_loading_keyword = false;
    })
  }

  //显示命中记录
  is_loading_hot_word:boolean = false;
  is_error_hot_word:boolean = false;
  hotWords = [];
  getHotWords(){
    this.is_loading_hot_word = true;
    this.is_error_hot_word = false;
    this.wordService.getHotWords(this.choosedChatroom?this.choosedChatroom.chatroomname:null,this.scope.value,this.wordTypeIndex).subscribe(res => {
        this.is_loading_hot_word = false;
        this.is_error_hot_word = false;
        //TODO:main function
        this.hotWords = res['content']['hot_words_data'];
    },
      err => {
        this.is_loading_hot_word = false;
        this.is_error_hot_word = true;
      })
  }



  showWordDetail(word){
    let modal = this._modal.create('WordRecordPage',{
      chatroomname:this.choosedChatroom?this.choosedChatroom.chatroomname:null,
      scope:this.scope.value,
      keyword:word,
    });
    modal.present();
    modal.onDidDismiss(() =>{

    })
  }




}



// WEBPACK FOOTER //
// ./src/components/hot-word/hot-word.ts